import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft
} from 'react-icons/fa';

const EngineerDistrictLotteryListReport = () => {
    const navigate = useNavigate();
    const [lotteryDate, setLotteryDate] = useState('२८ नोव्हेंबर २०२५');

    // Data from the image in Marathi
    const [data] = useState([
        { id: "१", workName: "जि.प. शाळा काळे ता. मावळ येथे दुरुस्ती", amount: "५०००००.००", institutionName: "कृष्णाई मजूर सहकारी संस्था मर्यादीत", phone: "९४२३२२१९१४" },
        { id: "२", workName: "जिप शाळा येवलेवाडी कडधे ता.मावळ येथे दुरुस्ती करणे", amount: "५०००००.००", institutionName: "कृष्णा मासाळ मजूर सहकारी संस्था मर्यादित", phone: "९५६१८९६४७७" },
        { id: "३", workName: "दामगुडा ता.वेल्हा येथील जीप स्कूल सीटची दुरुस्ती", amount: "५०००००.००", institutionName: "पद्मावती कामगार सहकारी संस्था मर्यादित", phone: "९८५०००४९०८" },
        { id: "४", workName: "जिप शाळा साखर ता.वेल्हा येथे दुरुस्ती करणे", amount: "४०००००.००", institutionName: "विजय, एक मजूर, एक मजूर, एक विवाहित महिला", phone: "८८०५८०५९९५" },
        { id: "५", workName: "जिप शाळा आंबवणे ता.वेल्हा येथे दुरुस्ती करणे", amount: "५०००००.००", institutionName: "व्यंकटेश मजूर सहकारी संस्था मर्या.", phone: "९९२११५३०२५" },
    ]);

    return (
        <EngineerLayout>
            <div className="p-8 bg-[#f4f7fe] min-h-screen font-hind">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-10 px-2 text-left">
                    <div className="flex items-center gap-6">
                        <button 
                            onClick={() => navigate('/engineer/lottery-reports-menu')}
                            className="p-4 bg-white rounded-2xl shadow-sm hover:bg-gray-50 transition-all text-gray-600 border border-gray-100 hover:scale-105 active:scale-95 group"
                        >
                            <FaArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                        </button>
                        <h1 className="text-2xl font-black text-gray-800 tracking-tight">जिल्हा सोडतीची लॉटरी यादी पहा</h1>
                    </div>
                    <div className="hidden md:flex items-center gap-3 text-[11px] font-black text-gray-400 bg-white px-6 py-3 rounded-2xl border border-gray-100 shadow-sm uppercase tracking-wider">
                        जिल्हा परिषद / <span className="text-purple-600">जिल्हा सोडतीची लॉटरी यादी पहा</span>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 mb-8">
                    <div className="flex flex-col md:flex-row gap-6 items-end">
                        <div className="space-y-2 text-left flex-1 max-w-md">
                            <label className="text-[14px] font-black text-gray-500 tracking-tight">लॉटरीची तारीख निवडा <span className="text-red-500">*</span></label>
                            <select 
                                className="w-full border border-gray-100 rounded-xl px-4 py-3 outline-none focus:border-purple-500 bg-gray-50/50 text-gray-700 font-bold transition-all appearance-none"
                                value={lotteryDate}
                                onChange={(e) => setLotteryDate(e.target.value)}
                            >
                                <option value="२८ नोव्हेंबर २०२५">२८ नोव्हेंबर २०२५</option>
                            </select>
                        </div>
                        <div>
                            <button className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-10 py-3 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center justify-center gap-2 uppercase tracking-wide">
                                शोध
                            </button>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="mt-10 overflow-hidden border border-gray-100 rounded-lg shadow-sm">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 text-[14px] font-black text-gray-800 text-left">
                                    <th className="px-6 py-5 border-r border-gray-100 w-16">#</th>
                                    <th className="px-6 py-5 border-r border-gray-100 min-w-[300px]">कामाचे नाव</th>
                                    <th className="px-6 py-5 border-r border-gray-100 min-w-[120px]">रक्कम</th>
                                    <th className="px-6 py-5 border-r border-gray-100 min-w-[300px]">संस्थेचे नाव</th>
                                    <th className="px-6 py-5 min-w-[150px]">फोन नंबर.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index} className="hover:bg-blue-50/10 transition-colors border-b border-gray-100 last:border-0 text-[15px] text-gray-700 font-bold">
                                        <td className="px-6 py-6 border-r border-gray-100 text-gray-500">{item.id}</td>
                                        <td className="px-6 py-6 border-r border-gray-100 leading-relaxed">{item.workName}</td>
                                        <td className="px-6 py-6 border-r border-gray-100">{item.amount}</td>
                                        <td className="px-6 py-6 border-r border-gray-100 text-[#1e293b]">{item.institutionName}</td>
                                        <td className="px-6 py-6">{item.phone}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Print Button */}
                    <div className="mt-10 flex justify-center">
                        <button 
                            className="bg-[#6366f1] hover:bg-[#4f46e5] text-white px-10 py-3 rounded-lg font-bold shadow-lg shadow-indigo-500/20 transition transform active:scale-95 flex items-center gap-2 uppercase tracking-wide"
                        >
                            प्रिंट
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
                .font-hind {
                    font-family: 'Hind', sans-serif;
                }
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerDistrictLotteryListReport;
